import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { WidgetsComponentAbstract } from 'src/app/abstract/widgets/widgets-component.abstracts';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { Logger } from 'src/app/core/logger';
import { WidgetsNoneModel } from 'src/app/models/widgets/widgets-none.model';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/config';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { QuestionPreviewService } from 'src/app/services/question-preview.service';
import { WidgetsQuestionModel } from 'src/app/models/widgets/widgets-question.model';
import { PermissionsService } from 'src/app/services/auth/permissions.service';
import { ActionsEnum } from 'src/app/enums/permissions/actions.enum';
@Component({
  selector: 'app-library-item',
  templateUrl: './widgets-library-item.component.html',
  styleUrls: ['./widgets-library-item.component.scss'],
})
export class WidgetsLibraryItemComponent {
  @Input() widget: WidgetsAbstract = new WidgetsNoneModel();
  @Input() isHidden: boolean = false;
  @Output() clickAction: EventEmitter<WidgetsAbstract> = new EventEmitter<WidgetsAbstract>();
  @Output() selectAction: EventEmitter<WidgetsAbstract> = new EventEmitter<WidgetsAbstract>();

  @ViewChild(MatMenuTrigger) contextMenu?: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };

  constructor(
    private logger: Logger,
    private questionPreviewService: QuestionPreviewService,
    private permissionService: PermissionsService,
    public toastr: ToastrService
  ) {
    // do nothing.
  }

  getItemTooltip(myWidget): string {
    return myWidget.description ? myWidget.description : myWidget.name;
  }

  onClickItem(myWidget: WidgetsAbstract) {
    this.clickAction.next(myWidget);
  }

  onSelectItem(myWidget: WidgetsAbstract) {
    this.selectAction.next(myWidget);
  }

  onContextMenu(event: MouseEvent, item) {
    const getFeature = Config.FEATURES.get('isContextMenuEnabled');
    if (getFeature && (getFeature === true) && this.widget instanceof WidgetsQuestionModel) {
      // For questions only, show context menu
      event.preventDefault();
      this.contextMenuPosition.x = event.clientX + 'px';
      this.contextMenuPosition.y = event.clientY + 'px';
      if (this.contextMenu) {
        this.contextMenu.menuData = { item };
        this.contextMenu.menu.focusFirstItem('mouse');
        this.contextMenu.openMenu();
      }
    }
  }

  hasUserEditPermission() {
    return this.permissionService.hasUserPermission(ActionsEnum.editQuestion);
  }

  onShowPreviewAction(data) {
    if (this.widget instanceof WidgetsQuestionModel) {
      // data used for preview Question data transfer
      this.questionPreviewService.data = this.widget as WidgetsQuestionModel;
      // booleanValue used to toggle preview dialog (show = true , hide = false)
      this.questionPreviewService.sendValue(true);
    }
  }

  onEditQuestionAction(data) {
    if (this.widget instanceof WidgetsQuestionModel) {
      this.onClickItem(this.widget);
    }
  }

  onToggleAction(item) {
    item.isSelected = !item.isSelected;
  }
}
